module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_null@3x.0907cd3e.png";